var Data = /** @class */ (function () {
    function Data() {
    }
    return Data;
}());
export { Data };
//# sourceMappingURL=data.js.map